import ParameterErrors from '../errors/ParameterErrors';
const {throwNotProvided }=ParameterErrors;
export default class WhenFinishedModifying {
    constructor(props){
		const {delay, callback}=props;
		this._delay = delay;
		if(!delay)
			throwNotProvided('delay');
		if(!callback)
			throwNotProvided('callback');
		this._callback = callback;
		this._currentTimeout= null;
		this.trigger= this.trigger.bind(this);
	}
	trigger(){
		if(this._currentTimeout)
			clearTimeout(this._currentTimeout);
		this._currentTimeout = setTimeout(()=>{
			this._callback();
		}, this._delay);
	}
}